<template lang="pug">
  .components-backoffice-parkinglots-overview
    .action-bar
      h2 Parking Lot Overview
    .tabs-inner-content(v-if="item")
      .row(v-if="item.layout" v-for="(svg, id) in item.layout")
        strong.text-center ID: {{ id }}
        svg(:viewBox="svg.viewBox", preserveAspectRatio="xMidYMid meet", xmlns="http://www.w3.org/2000/svg")
          g
            path(v-for="(d, id) in svg.paths", :d="d.d", :transform="d.t", :class="getClass(id)", @mouseover="tooltip(id)" @click="clicked(id)")
        p.center {{ tooltipText }}
      .row
        .column.small-5
          img(:src="item.picture_external")
        .column.small-7
          .card
            h3 Description
            .description(v-html="item.description")
            h3 Allowed Zone
            p(v-if="item.allowed_zone") {{item.allowed_zone.name}}
            p(v-else) --
            h3 Undesiderable Zone
            p(v-if="item.undesiderable_zone") {{item.undesiderable_zone.name}}
            p(v-else) --
            h3 Forbidden Zone
            p(v-if="item.forbidden_zone") {{item.forbidden_zone.name}}
            p(v-else) --
    loading-spinner(v-else)
</template>

<script>
  import KeplerBackofficeSdk from "../../../lib/kepler/backoffice";
  import LoadingSpinner from "../../structure/LoadingSpinner";

  export default {
    name: "ParkingLotsOverview",
    components: {LoadingSpinner},
    data() {
      return {
        item: null,
        tooltipText: "",
        status: {},
      }
    },
    created() {
      KeplerBackofficeSdk.parkingLots.select(this.$route.params.id).get((data) => {
        this.status = {}
        data['parking_slots'].forEach((s)=> {
          if(typeof s.occupied === "boolean") {
            this.status[s.name] = s.occupied
          }
        })

        this.item = data
      })
    },
    methods: {
      tooltip(id, g) {
        this.tooltipText = id
      },

      clicked(id) {
        alert(id)
      },
      getClass(id) {
        if (typeof this.status[id] === "undefined") {
          return 'outline'
        }
        return this.status[id] ? 'occupied' : 'free'
      }
    }
  }
</script>

<style scoped>
.outline{fill:#c2c2c2;stroke:#000;stroke-miterlimit:10; opacity: 0.6;}
.occupied{opacity:.3;fill:#f15a24;stroke:#000;stroke-miterlimit:10;}
.free{opacity:.3;fill: #a9f124;stroke:#000;stroke-miterlimit:10;}
</style>



// WEBPACK FOOTER //
// ParkingLotsOverview.vue?1731e096